export default __webpack_public_path__ + "static/media/AT.72c5ad30.svg";